// extracted by mini-css-extract-plugin
module.exports = {"list":"FooterLegal_list__eDYHG","link":"FooterLegal_link__32pZY"};